export default function WelcomeSection() {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 mb-6 md:mb-8">
          Blumen erzählen Geschichten.
        </h2>
        <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
          Ob als liebevolle Aufmerksamkeit, festlicher Blumenschmuck, Zeichen der Verbundenheit oder stiller Abschiedsgruß – wir gestalten Floristik, die zum Menschen und zum Anlass passt.
        </p>
        <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
          Mit viel Gespür, handwerklicher Erfahrung und einem Blick für besondere Details entstehen in unserer Floralen Manufaktur individuelle Werkstücke.
        </p>
      </div>
    </section>
  );
}